import React, {Component} from 'react';
import './RadioButtonGroup.css';
import InitialAdminState from "../../../Admin/AdminRoot/InitialAdminState";

class RadioButton extends Component {

    render() {
        let cssClassName = this.props.data.checked ?
            "radio-button checked-radio-button" : "radio-button";
        let cssDot = (this.props.data.name === "pcbColor") ? "dot-"+this.props.data.id :
            "dot";

        let cssDisable = (this.props.data.disabled === true) ? " css-disabled": "";

        return (
            <div className={cssClassName+cssDisable}
                 onClick={() => this.props.onRadioButtonClicked(this.props.data)}>
                <span className={cssDot}></span>{this.props.data.text}
            </div>
        )
    }
}

class RadioButtonGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            buttons: [...props.data],
        };

        this.onRadioButtonClicked = this.onRadioButtonClicked.bind(this);
    }

    onRadioButtonClicked = (data) => {
        InitialAdminState.radioBtnClick=true;
        let buttons = this.state.buttons.map((btn) => {
            if (btn.id === data.id) {
                this.props.getParams({...btn});
                return {...btn, checked: true}
            } else {
                return {...btn, checked: false}
            }
        });
        this.setState({
            buttons
        });

    };

    render() {
        return (
            <div className="radio-button-group">
                {this.state.buttons.map((btn) => {
                    return <RadioButton data={btn} key={btn.id}
                                        onRadioButtonClicked={this.onRadioButtonClicked}/>
                })}
            </div>
        )
    }

}

export default RadioButtonGroup;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/RadioButtonGroup/RadioButtonGroup.js